export const POST = "post";
export const PROFILE = "profile";
export const STREAM = "stream";
export const HAPPY_MOMENTS = "happyMoments";
export const UNSET = "UNSET";
export const CHAT = "CHAT";
